import * as React from "react";
const SvgLargeCheck = (props) => /* @__PURE__ */ React.createElement("svg", { id: "uuid-368a48ac-f530-499e-a056-7eaac20005a9", "data-name": "LargeCheck", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "m3.72,13.53l4.37,4.37c.34.34.88.34,1.22,0l10.8-10.8", style: {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "square",
  strokeWidth: "1.3px"
} }));
export default SvgLargeCheck;
